module.exports = __webpack_public_path__ + "media/assets/images/flags/py-f119a69b384d5bad4e45c25fa9790563.svg";